import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=7dc624a1&scoped=true&"
import script from "./Vendors.vue?vue&type=script&lang=js&"
export * from "./Vendors.vue?vue&type=script&lang=js&"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=7dc624a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc624a1",
  null
  
)

export default component.exports